import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=281baeb4&"
import script from "./Dimensions.vue?vue&type=script&lang=js&"
export * from "./Dimensions.vue?vue&type=script&lang=js&"
import style0 from "./Dimensions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn,QSelect,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn,QSelect,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
